import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box } from '@mui/material';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import CustomisedOtpInputAutoFill from '../../components/otpInput/otpInputAutoFill';
import {
    MAX_WIDTH_OBJ,
    MOBILE,
    NATIONAL_CODE,
    OTP_lENGTH,
    REF_OTP,
    TIME_OTP,
    UUID
} from '../../config/cacheKey';
import { ICheckOtpResponse, ISendOtpResponse } from '../../models/account.model';
import { ApiResultModel } from '../../models/common.model';
import { AppDispatch } from '../../redux/store';
import { setUnAuthorizedState } from '../../redux/unAuthorizedState/unAuthorizedStateSlice';
import { IRouteWithState } from '../../routeWithState/IRouteWithState';
import { CheckOtp, sendOtp } from '../../services/account.service';
import { setJwtToken } from '../../services/auth.service';

export default function Otp({ setState }: IRouteWithState) {
    const [otp, setOtp] = useState('');
    const [disable, setDisable] = useState(true);
    const queryClient = useQueryClient();

    const mobile = String(queryClient.getQueryData(MOBILE));
    const nationalCode = String(queryClient.getQueryData(NATIONAL_CODE));
    const otpTime = Number(queryClient.getQueryData(TIME_OTP));
    const refOtP = String(queryClient.getQueryData(REF_OTP));
    const dispatch: AppDispatch = useDispatch();
    const otpLenght = Number(queryClient.getQueryData(OTP_lENGTH));
    useEffect(() => {
        setDisable(true);
        if (otp.length === otpLenght) {
            setDisable(false);
            handleBtnClick(otp);
        }
    }, [otp]);
    useEffect(() => {
        if (mobile == 'undefined') {
            dispatch(setUnAuthorizedState({ state: `login ${UUID}` }));

        }
    }, []);
    const { mutateAsync: checkOtpMutation, isLoading } = useMutation(CheckOtp, {
        onSuccess: (data: ApiResultModel<ICheckOtpResponse>) => {
            if (data) {
                setJwtToken(data.data.jwt!, data.data.refreshToken!);
                dispatch(setUnAuthorizedState({ state: `routeWithState ${UUID}` }));



            }
        },
        onError: () => { },
    });
    const { mutateAsync: sendOptMutation, isLoading: sendOtpLodaing } =
        useMutation(sendOtp, {
            onSuccess: (data: ISendOtpResponse) => {
                if (data) {
                    queryClient.setQueryData(REF_OTP, data.key);
                    queryClient.setQueryData(TIME_OTP, data.otpLifetime);
                }
            },
        });


    function handleBtnClick(values: string) {
        checkOtpMutation({ key: refOtP, otp: values });
    }
    return (
        <Box
            maxWidth={MAX_WIDTH_OBJ}
            style={{
                textAlign: 'center',
                display: 'block',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                position: 'relative',
                top: '50%',
                transform: 'translateY(-50%)',
            }}
        >
            <div className="px-5">

                <div
                    className="text-center !mb-10"
                    style={{ paddingTop: '10px' }}
                >
                    {/* <CustomisedTitleFont14 title={' ورود به  کمان لند'} /> */}

                    <div className="primaryColorLight-900 mt-5 mb-10" >
                        {/* کد تایید را به شماره موبایل
                        <b className="yekanBakhFaNum primaryColorLight-100">
                            &nbsp;{mobile}&nbsp;
                        </b>
                        فرستادیم. */}
                        لطفا کد ارسال شده به شماره همراه خود را وارد نمایید.
                    </div>
                </div>
                <Formik
                    initialValues={new String()}
                    onSubmit={(values) => {
                        values = otp;
                        handleBtnClick(otp);
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <form onSubmit={handleSubmit}>
                            <div
                                className="text-center mb-8 flex justify-between items-center"

                            >
                                <span className="primaryColorLight !text-sm">
                                    {/* شماره موبایل شما: */}
                                    <span className="primaryColorLight-100">
                                        &nbsp;
                                        {mobile.length > 4
                                            ? `${mobile.slice(0, 4)}-${mobile.slice(4)}`
                                            : mobile}
                                        &nbsp;
                                    </span>
                                </span>
                                <b
                                    className="primaryColorLight !text-sm"
                                    onClick={() => {
                                        dispatch(setUnAuthorizedState({ state: `login ${UUID}` }));

                                    }}
                                >
                                    <EditOutlinedIcon sx={{ marginLeft: "5px", fontSize: "1.2rem" }} />
                                    اصلاح شماره
                                </b>
                            </div>
                            <div>
                                <CustomisedOtpInputAutoFill
                                    otp={otp}
                                    setOtp={setOtp}
                                    numInputs={otpLenght}
                                    otpTime={otpTime}
                                    resendOtp={() =>
                                        sendOptMutation({
                                            mobileNumber: mobile,
                                            nationalCode: nationalCode,
                                        })
                                    }
                                />
                            </div>

                            {/* <div style={{ marginTop: '3.3rem' }}>
                                <CustomisedButton
                                    title={'ورود'}
                                    disable={disable}
                                    onClick={() => { }}
                                    type="submit"
                                />
                            </div> */}
                            {/* <PrivacyLink onClick={() => { dispatch(setUnAuthorizedState({ state: `privacyStatementsOtp ${UUID}` })) }} /> */}

                        </form>
                    )}
                </Formik>
            </div>

        </Box>
    );
}
